import React from 'react';

import WidgetNewportAppSettingsEditor from 'widgets/WidgetSettingsEditing/WidgetNewportAppSettingsEditor';
import { useWidgetConfigUpdater } from 'widgets/WidgetSettingsEditing/useWidgetConfigUpdater';

import WidgetSettingsCheckboxValueEditor from 'widgets/WidgetSettingsEditing/WidgetSettingsCheckboxValueEditor';
import { VenueAnalysisCapsuleConfigState } from 'widgets/venueAnalysis/capsules/store/VenueAnalysisCapsuleConfigState';
import { CapsuleSettingsSymbolEditor } from 'widgets/tiles/components/tile/CapsuleSettingsSymbolEditor';
import { useOrderLiquidityCapsuleConfigSlice } from '../store/configslice';

export const OrderLiquidityCapsuleSettingsText = `OrderLiquidity Capsule Settings`;

export interface OrderLiquidityCapsuleSettingsProps {
    config?: VenueAnalysisCapsuleConfigState;
    onChange?: (nextDelta: Partial<VenueAnalysisCapsuleConfigState>) => void;
}

export default function OrderLiquidityCapsuleSettings(
    props: OrderLiquidityCapsuleSettingsProps
) {
    const { onChange, config: propsConfig } = props;
    const { config: configSliceConfig, dispatchConfigChanged } =
        useOrderLiquidityCapsuleConfigSlice();

    const { debouncedApplyWidgetConfigChange } = useWidgetConfigUpdater(
        dispatchConfigChanged,
        onChange
    );
    const config = propsConfig ?? configSliceConfig;

    return (
        <div className="OrderLiquiditycCapsuleSettings">
            <div className="group ">
                <CapsuleSettingsSymbolEditor
                    config={config}
                    onChange={debouncedApplyWidgetConfigChange}
                />
            </div>

            <WidgetSettingsCheckboxValueEditor
                propertyName="includePreviousDaysFills"
                config={config!}
                label="Show portion of order filled in previous days' trading"
                onChange={debouncedApplyWidgetConfigChange}
            />

            <WidgetNewportAppSettingsEditor />
        </div>
    );
}
